import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["template", "container"];

  declare readonly templateTarget: HTMLTemplateElement;
  declare readonly containerTarget: HTMLElement;

  add(event: Event) {
    event.preventDefault();
    const index = this.containerTarget.children.length;
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime().toString(),
    );
    this.containerTarget.insertAdjacentHTML("beforeend", content);

    // Update positions after adding
    this.updatePositions();

    // Focus the first editable input in the newly added field so users can
    // start typing immediately. Skip hidden position/destroy fields.
    const newField = this.containerTarget.lastElementChild;
    if (newField) {
      const input = newField.querySelector<HTMLInputElement | HTMLTextAreaElement>(
        'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), textarea',
      );
      if (input) {
        input.focus();
      }
    }

    // Dispatch event to reinitialize sortable if needed
    this.dispatch("itemAdded", { target: this.containerTarget });
  }

  remove(event: Event) {
    event.preventDefault();
    const wrapper = (event.target as HTMLElement).closest(".nested-fields");
    if (wrapper) {
      const destroyField = wrapper.querySelector(
        'input[name*="_destroy"]',
      ) as HTMLInputElement;
      if (destroyField) {
        destroyField.value = "1";
        wrapper.style.display = "none";
        // Setting .value programmatically does not fire an event, so
        // dispatch a bubbling `change` to notify auto-save listeners
        // (e.g. question-auto-save) that the form is now dirty.
        destroyField.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        wrapper.remove();
      }

      // Update positions after removal
      this.updatePositions();
    }
  }

  private updatePositions() {
    const visibleItems = this.containerTarget.querySelectorAll(
      ".nested-fields:not([style*='display: none'])",
    );
    visibleItems.forEach((item, index) => {
      const positionField = item.querySelector(
        'input[name*="[position]"]',
      ) as HTMLInputElement;
      if (positionField) {
        positionField.value = (index + 1).toString();
      }
    });
  }
}
